import { render, staticRenderFns } from "./FormWarehouse.vue?vue&type=template&id=545f7cb2&scoped=true"
import script from "./FormWarehouse.vue?vue&type=script&lang=js"
export * from "./FormWarehouse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545f7cb2",
  null
  
)

export default component.exports